"use strict";

var _slicedToArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MarkdownSerializer = /*#__PURE__*/function () {
  function MarkdownSerializer(nodes, marks) {
    _classCallCheck(this, MarkdownSerializer);

    this.nodes = nodes;
    this.marks = marks;
  }

  _createClass(MarkdownSerializer, [{
    key: "serialize",
    value: function serialize(content, options) {
      var state = new MarkdownSerializerState(this.nodes, this.marks, options);
      state.renderContent(content);
      return state.out;
    }
  }]);

  return MarkdownSerializer;
}();

exports.MarkdownSerializer = MarkdownSerializer;

var MarkdownSerializerState = /*#__PURE__*/function () {
  function MarkdownSerializerState(nodes, marks, options) {
    _classCallCheck(this, MarkdownSerializerState);

    this.nodes = nodes;
    this.marks = marks;
    this.delim = this.out = "";
    this.closed = false;
    this.inTightList = false;
    this.options = options || {};
    if (typeof this.options.tightLists === "undefined") this.options.tightLists = true;
  }

  _createClass(MarkdownSerializerState, [{
    key: "flushClose",
    value: function flushClose(size) {
      if (this.closed) {
        if (!this.atBlank()) this.out += "\n";
        if (size === null || size === undefined) size = 2;

        if (size > 1) {
          var delimMin = this.delim;
          var trim = /\s+$/.exec(delimMin);
          if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);

          for (var i = 1; i < size; i++) {
            this.out += delimMin + "\n";
          }
        }

        this.closed = false;
      }
    }
  }, {
    key: "wrapBlock",
    value: function wrapBlock(delim, firstDelim, node, f) {
      var old = this.delim;
      this.write(firstDelim || delim);
      this.delim += delim;
      f();
      this.delim = old;
      this.closeBlock(node);
    }
  }, {
    key: "atBlank",
    value: function atBlank() {
      return /(^|\n)$/.test(this.out);
    }
  }, {
    key: "ensureNewLine",
    value: function ensureNewLine() {
      if (!this.atBlank()) this.out += "\n";
    }
  }, {
    key: "write",
    value: function write(content) {
      this.flushClose();
      if (this.delim && this.atBlank()) this.out += this.delim;
      if (content) this.out += content;
    }
  }, {
    key: "closeBlock",
    value: function closeBlock(node) {
      this.closed = node;
    }
  }, {
    key: "text",
    value: function text(_text, escape) {
      var lines = _text.split("\n");

      for (var i = 0; i < lines.length; i++) {
        var startOfLine = this.atBlank() || this.closed;
        this.write();
        this.out += escape !== false ? this.esc(lines[i], startOfLine) : lines[i];
        if (i !== lines.length - 1) this.out += "\n";
      }
    }
  }, {
    key: "render",
    value: function render(node, parent, index) {
      if (typeof parent === "number") throw new Error("!");
      this.nodes[node.type.name](this, node, parent, index);
    }
  }, {
    key: "renderContent",
    value: function renderContent(parent) {
      var _this = this;

      parent.forEach(function (node, _, i) {
        return _this.render(node, parent, i);
      });
    }
  }, {
    key: "renderInline",
    value: function renderInline(parent) {
      var _this2 = this;

      var active = [];
      var trailing = "";

      var progress = function progress(node, _, index) {
        var marks = node ? node.marks : [];
        if (node && node.type.name === "hard_break") marks = marks.filter(function (m) {
          if (index + 1 === parent.childCount) return false;
          var next = parent.child(index + 1);
          return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
        });
        var leading = trailing;
        trailing = "";

        if (node && node.isText && marks.some(function (mark) {
          var info = _this2.marks[mark.type.name];
          return info && info.expelEnclosingWhitespace;
        })) {
          var _$exec = /^(\s*)(.*?)(\s*)$/m.exec(node.text),
              _$exec2 = _slicedToArray(_$exec, 4),
              _2 = _$exec2[0],
              lead = _$exec2[1],
              _inner = _$exec2[2],
              trail = _$exec2[3];

          leading += lead;
          trailing = trail;

          if (lead || trail) {
            node = _inner ? node.withText(_inner) : null;
            if (!node) marks = active;
          }
        }

        var inner = marks.length && marks[marks.length - 1],
            noEsc = inner && _this2.marks[inner.type.name].escape === false;
        var len = marks.length - (noEsc ? 1 : 0);

        outer: for (var i = 0; i < len; i++) {
          var mark = marks[i];
          if (!_this2.marks[mark.type.name].mixable) break;

          for (var j = 0; j < active.length; j++) {
            var other = active[j];
            if (!_this2.marks[other.type.name].mixable) break;

            if (mark.eq(other)) {
              if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
              continue outer;
            }
          }
        }

        var keep = 0;

        while (keep < Math.min(active.length, len) && marks[keep].eq(active[keep])) {
          ++keep;
        }

        while (keep < active.length) {
          _this2.text(_this2.markString(active.pop(), false, parent, index), false);
        }

        if (leading) _this2.text(leading);

        if (node) {
          while (active.length < len) {
            var add = marks[active.length];
            active.push(add);

            _this2.text(_this2.markString(add, true, parent, index), false);
          }

          if (noEsc && node.isText) _this2.text(_this2.markString(inner, true, parent, index) + node.text + _this2.markString(inner, false, parent, index + 1), false);else _this2.render(node, parent, index);
        }
      };

      parent.forEach(progress);
      progress(null, null, parent.childCount);
    }
  }, {
    key: "renderList",
    value: function renderList(node, delim, firstDelim) {
      var _this3 = this;

      if (this.closed && this.closed.type === node.type) this.flushClose(3);else if (this.inTightList) this.flushClose(1);
      var isTight = typeof node.attrs.tight !== "undefined" ? node.attrs.tight : this.options.tightLists;
      var prevTight = this.inTightList;
      var prevList = this.inList;
      this.inList = true;
      this.inTightList = isTight;
      node.forEach(function (child, _, i) {
        if (i && isTight) _this3.flushClose(1);

        _this3.wrapBlock(delim, firstDelim(i), node, function () {
          return _this3.render(child, node, i);
        });
      });
      this.inList = prevList;
      this.inTightList = prevTight;
    }
  }, {
    key: "renderTable",
    value: function renderTable(node) {
      var _this4 = this;

      this.flushClose(1);
      var headerBuffer = "";
      var prevTable = this.inTable;
      this.inTable = true;
      node.forEach(function (row, _, i) {
        if (headerBuffer) {
          _this4.out += "".concat(headerBuffer, "|\n");
          headerBuffer = undefined;
        }

        row.forEach(function (cell, _, j) {
          _this4.out += j === 0 ? "| " : " | ";
          cell.forEach(function (para) {
            if (para.textContent === "") {
              _this4.out += "  ";
            } else {
              _this4.closed = false;

              _this4.render(para, row, j);
            }
          });

          if (i === 0) {
            if (cell.attrs.alignment === "center") {
              headerBuffer += "|:---:";
            } else if (cell.attrs.alignment === "left") {
              headerBuffer += "|:---";
            } else if (cell.attrs.alignment === "right") {
              headerBuffer += "|---:";
            } else {
              headerBuffer += "|----";
            }
          }
        });
        _this4.out += " |\n";
      });
      this.inTable = prevTable;
    }
  }, {
    key: "esc",
    value: function esc(str, startOfLine) {
      str = str.replace(/[`*\\~\[\]]/g, "\\$&");

      if (startOfLine) {
        str = str.replace(/^[:#\-*+]/, "\\$&").replace(/^(\d+)\./, "$1\\.");
      }

      if (this.inTable) {
        str = str.replace(/\|/gi, "\\$&");
      }

      return str;
    }
  }, {
    key: "quote",
    value: function quote(str) {
      var wrap = str.indexOf('"') === -1 ? '""' : str.indexOf("'") === -1 ? "''" : "()";
      return wrap[0] + str + wrap[1];
    }
  }, {
    key: "repeat",
    value: function repeat(str, n) {
      var out = "";

      for (var i = 0; i < n; i++) {
        out += str;
      }

      return out;
    }
  }, {
    key: "markString",
    value: function markString(mark, open, parent, index) {
      var info = this.marks[mark.type.name];
      var value = open ? info.open : info.close;
      return typeof value === "string" ? value : value(this, mark, parent, index);
    }
  }, {
    key: "getEnclosingWhitespace",
    value: function getEnclosingWhitespace(text) {
      return {
        leading: (text.match(/^(\s+)/) || [])[0],
        trailing: (text.match(/(\s+)$/) || [])[0]
      };
    }
  }]);

  return MarkdownSerializerState;
}();

exports.MarkdownSerializerState = MarkdownSerializerState;